export const getSentryDsn = (): string | undefined => process.env.NEXT_PUBLIC_SENTRY_DSN;

/** Runtime reporting requires both a DSN and a non-empty SENTRY_ENVIRONMENT (Cloud Run UAT/prod). */
export const isSentryEnabled = (): boolean => {
  const environment = process.env.SENTRY_ENVIRONMENT?.trim();
  return Boolean(getSentryDsn() && environment);
};

export const getSampleRate = (value: number): number => {
  if (process.env.SENTRY_ENVIRONMENT !== 'production') {
    console.log(`Overwriting Sentry sample rate from ${value} to 1.0`);
    return 1.0;
  }
  return value;
};
